import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system/styleFunctionSx';
import { ReactNode } from 'react';

import { frostedPanelSx } from 'src/common/styles/frostedPanelStyles';

const insightsPanelPaperSx: SystemStyleObject<Theme> = {
  ...frostedPanelSx(0.5),
  width: '100%',
  mt: 0,
  mb: 2,
};

interface Props {
  children: ReactNode;
  sx?: SystemStyleObject<Theme>;
}

export default function InsightsPanelSurface({ children, sx }: Props) {
  return <Paper sx={{ ...insightsPanelPaperSx, ...sx }}>{children}</Paper>;
}
